import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./vee-validate";
import axios from "axios";

import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@voerro/vue-tagsinput/dist/style.css";
import "@/config/validation";
import "@/util/functions";

import { setInteractionMode } from 'vee-validate';
setInteractionMode('lazy');

import WebFont from 'webfontloader';
WebFont.load(
  {
    custom: {
      families: ['Material Icons', 'icomoon']
    }
  }
);


let token;
try {
  token = localStorage.getItem('auth_token');
} catch (e) {
  console.warn('localStorage not available:', e);
}

if (token) {
  axios.defaults.headers.common['Authorization'] = token;
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
  axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';
}

import { setupAxiosInterceptor } from '@/util/axios-interceptor';
setupAxiosInterceptor(store);

import { installSuperAdminAxiosInterceptor } from '@/util/super_admin_passphrase';
installSuperAdminAxiosInterceptor();

Vue.config.productionTip = false;

// Global error handler — catch crashes and allow recovery
Vue.config.errorHandler = function (err) {
  console.error('[Vue Error]', err);
};
window.addEventListener('error', function (event) {
  // Ignore resource load failures (img/script/link). These bubble to window
  // as ErrorEvents with a target element but no `error` object, and they are
  // NOT page crashes — showing the recovery overlay for a failed image load
  // was the root cause of the "Something went wrong, reload page" modal
  // when opening chat images.
  if (event && event.target && event.target !== window && event.target.nodeType === 1) return;
  if (event && !event.error) return;
  // Ignore uncaught exceptions thrown from inside Google's reCAPTCHA scripts.
  // Invisible reCAPTCHA occasionally throws "Cannot read properties of null
  // (reading 'style')" from its own animation queue when its iframe is torn
  // down (e.g. after a verifier reset). These are harmless to our app and
  // must not trigger the full-page recovery overlay.
  if (event && event.filename && /gstatic\.com\/recaptcha|google\.com\/recaptcha|recaptcha[_]+(en|api)\.js/.test(event.filename)) return;
  // If the page crashes, show a recovery button
  if (!document.getElementById('crash-recovery')) {
    const overlay = document.createElement('div');
    overlay.id = 'crash-recovery';
    overlay.style.cssText = 'position:fixed;inset:0;background:#f3f3f3;display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:99999;font-family:-apple-system,sans-serif;';
    overlay.innerHTML = '<h2 style="color:#2c2c2e;font-size:24px;margin-bottom:8px;">Something went wrong</h2><p style="color:#8e8e93;font-size:16px;margin-bottom:24px;">An unexpected error occurred.</p><button onclick="location.reload();" style="background:#061D47;color:#fff;border:none;padding:12px 28px;border-radius:10px;font-size:16px;font-weight:600;cursor:pointer;">Reload page</button>';
    document.body.appendChild(overlay);
  }
});

window.EventBus = new Vue;

import { mapState } from 'vuex';
import VueGeolocation from 'vue-browser-geolocation';
import vuetify from "./plugins/vuetify";
// import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import * as VueGoogleMaps from 'vue2-google-maps';
import vueMoment from "vue-moment";

// @see https://www.npmjs.com/package/vue2-google-maps
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_FIREBASE_API_KEY,
    libraries: 'places',
    loading: 'async',
  },
});

Vue.use(VueGeolocation);

new Vue({
  router,
  store,
  vuetify,
  vueMoment,
  mapState,
  render: (h) => h(App),
}).$mount("#app");
